const Icon = (props: any) => {
    return (
        <svg width={19} height={16} viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M12.59 15v-1.556c0-.825-.325-1.616-.905-2.2a3.08 3.08 0 00-2.185-.91H4.09a3.08 3.08 0 00-2.185.91 3.122 3.122 0 00-.905 2.2V15M6.794 7.222a3.101 3.101 0 003.09-3.11A3.101 3.101 0 006.795 1a3.101 3.101 0 00-3.09 3.111 3.101 3.101 0 003.09 3.111zM15.685 4.889v4.666M18 7.223h-4.637"
                stroke="currentColor"
                strokeWidth={props.strokeWidth || 1.6}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default Icon;
